import { useEffect } from 'react';

import { useGetCommonStore } from '@/store';

export const useResetPromoStore = () => {
  const useCommonStore = useGetCommonStore();

  useEffect(() => {
    useCommonStore.setState({
      regBanner: null,
      registrationTheme: 'default',
      initialRegFormCurrency: null,
    });
  }, [useCommonStore]);
};
